var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimedoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100.5C40.8854 100.37 32.5521 98.1562 25 93.8594C17.4479 89.4323 11.3281 83.3125 6.64062 75.5C2.21354 67.5573 0 59.224 0 50.5C0 41.776 2.21354 33.4427 6.64062 25.5C11.3281 17.6875 17.4479 11.5677 25 7.14062C32.5521 2.84375 40.8854 0.630208 50 0.5C59.1146 0.630208 67.4479 2.84375 75 7.14062C82.5521 11.5677 88.6719 17.6875 93.3594 25.5C97.7865 33.4427 100 41.776 100 50.5C100 59.224 97.7865 67.5573 93.3594 75.5C88.6719 83.3125 82.5521 89.4323 75 93.8594C67.4479 98.1562 59.1146 100.37 50 100.5ZM34.1797 34.6797C32.3568 36.8932 32.3568 39.1068 34.1797 41.3203L43.3594 50.5L34.1797 59.6797C32.3568 61.8932 32.3568 64.1068 34.1797 66.3203C36.3932 68.1432 38.6068 68.1432 40.8203 66.3203L50 57.1406L59.1797 66.3203C61.3932 68.1432 63.6068 68.1432 65.8203 66.3203C67.6432 64.1068 67.6432 61.8932 65.8203 59.6797L56.6406 50.5L65.8203 41.3203C67.6432 39.1068 67.6432 36.8932 65.8203 34.6797C63.6068 32.8568 61.3932 32.8568 59.1797 34.6797L50 43.8594L40.8203 34.6797C38.6068 32.8568 36.3932 32.8568 34.1797 34.6797Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimedoutIcon);
export default __webpack_public_path__ + "static/media/timedoutIcon.cfe51c33872c07e562942890b82a42b9.svg";
export { ForwardRef as ReactComponent };